import { createAction } from "typesafe-actions";

import type { CrmListObjectType } from "../../management/types";
import type { CompanySearchOtherFilters } from "../types/common";

export const updateOtherFiltersAction = createAction("@@si/company-search/other-filters-updated")<
    Partial<CompanySearchOtherFilters>
>();

export const otherFiltersClearedAction = createAction("@@si/company-search/other-filters-cleared")();

export const setIsExcelExportActive = createAction("@@si/company-search/set-is-excel-export-active")<boolean>();

export const initExportToCrmAs = createAction("@@si/company-search/init-export-to-crm-as")<
    CrmListObjectType.Accounts | CrmListObjectType.Leads
>();
